/* knack-sticker.js — scroll-driven rotation + parallax for decorative ball stickers */
(function () {
  'use strict';

  const stickers = [];

  function init() {
    document.querySelectorAll('[data-knack-sticker]').forEach(function (el) {
      /* Hoist the ball out of any centered content column (e.g. the hero inner where content_for
         renders blocks) up to its host section, so its top/left % is relative to the FULL-WIDTH
         section and the balls spread to the left/right edges instead of clustering in the centre. */
      var host = el.closest('.knack-hero, .knack-featured-products, .knack-collection-header');
      if (host && el.parentElement !== host) {
        host.appendChild(el);
      }
      stickers.push({
        el: el,
        rotateEl: el.querySelector('.knack-sticker__rotate'),
        parallaxSpeed: parseFloat(el.dataset.knackParallax || '0'),
        rotateSpeed: parseFloat(el.dataset.knackRotate || '0'),
        deg: parseFloat(el.dataset.knackInitialRotation || '0'),
        parallaxY: 0,
      });
    });

    if (stickers.length === 0) return;

    var lastScrollY = window.scrollY;
    var ticking = false;

    function update() {
      var scrollY = window.scrollY;
      var delta = scrollY - lastScrollY;
      lastScrollY = scrollY;

      stickers.forEach(function (s) {
        if (s.rotateSpeed !== 0 && s.rotateEl) {
          s.deg += delta * s.rotateSpeed * 0.07;
          s.rotateEl.style.transform = 'rotate(' + s.deg + 'deg)';
        }
        if (s.parallaxSpeed !== 0) {
          s.parallaxY += delta * s.parallaxSpeed * 0.05;
          s.el.style.transform = 'translate3d(0,' + s.parallaxY + 'px,0)';
        }
      });

      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
